import Api from '.';
import { DEVURL, SITURL, PRODURL } from './envUrl';

export const submitWave = async (formData) => {
  let headers = {
    'Content-Type': 'application/json',
    'Content-Language': 'en-US',
    'Access-Control-Allow-Origin': '*',
  }

  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL;
  apiURL = `${DEVURL}/submitWaveDetails`;

  const submitWaveData = await axiosInstance({
    url: apiURL,
    method: 'POST',
    data: formData,
  });
  return submitWaveData;
};

